import React from 'react';
import '../../../assets/css/how-pay-earth-works.css';

const DEFAULT_WALKTHROUGH_VIDEO_URL =
  'https://storage.googleapis.com/payearth-storage/public%20files/WhatsApp%20Video%202026-04-12%20at%2014.09.43.mp4';

const HowPayEarthWorks = () => {
  const videoSrc =
    (process.env.REACT_APP_PLATFORM_WALKTHROUGH_VIDEO_URL || '').trim() ||
    DEFAULT_WALKTHROUGH_VIDEO_URL;

  return (
    <section
      className="how-pay-earth-works-sec"
      aria-labelledby="how-pay-earth-works-heading"
    >
      <div className="container">
        <h2 id="how-pay-earth-works-heading" className="how-pay-earth-works-title">
          How Pay.Earth Works
        </h2>
        <div className="how-pay-earth-works-player-wrap">
          <video
            className="how-pay-earth-works-video"
            src={videoSrc}
            controls
            controlsList="nodownload"
            playsInline
            preload="metadata"
          >
            Your browser does not support embedded video playback.
          </video>
        </div>
      </div>
    </section>
  );
};

export default HowPayEarthWorks;
